import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}

/* THIS APP MANAGES ITS OWN SCROLL, so the browser must stop managing it too.
 *
 * `history.scrollRestoration` defaults to 'auto', which means the browser records the offset
 * of the entry you are leaving and reapplies it on the next one — and it does that on its own
 * schedule, AFTER the app has already reset to the top. The browser acts last, so the browser
 * wins, and you land partway down a page you have never seen. How far down depends on how far
 * you had scrolled the previous page, which is what makes it look arbitrary.
 *
 * That is one cause for two reports: generating cuts from a scrolled Home to the Workspace,
 * and tapping a card goes from a scrolled Workspace to a video — the arrival is different, the
 * restoration is identical. It is also why this survived a scroll reset, then a settle-timed
 * reset: none of them were losing a race with a late scroll, they were being overwritten by
 * the browser afterwards.
 *
 * 'manual' does not lose anything the app was relying on. RouteTransitionManager already keeps
 * per-path offsets and restores them for the Workspace and Explore, which is precisely the
 * work this setting duplicates and then overrides. Set at the entry point so it is in force
 * before the first navigation.
 */
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);